<style>
  /* Reset e configurações básicas */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  :root {
    --vh: 1vh;
    --primary-gradient: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    --secondary-gradient: linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%);
    --accent-color: #667eea;
    --text-primary: #1f2937;
    --text-secondary: #6b7280;
    --white: #ffffff;
    --shadow-soft: 0 10px 30px rgba(0, 0, 0, 0.1);
    --shadow-medium: 0 20px 60px rgba(0, 0, 0, 0.15);
    --border-radius: 20px;
    --transition: all 0.3s ease;
  }

  html, body {
    height: 100%;
    height: calc(var(--vh, 1vh) * 100);
    overflow-x: hidden;
    font-family: 'Sora', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  .fundo-mahila {
    min-height: 100vh;
    min-height: calc(var(--vh, 1vh) * 100);
    width: 100vw;
    background: var(--primary-gradient);
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
    overflow-x: hidden;
  }

  .fundo-mahila::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('../assets/5935675.jpg');
    background-position: center;
    background-size: cover;
    background-attachment: fixed;
    opacity: 0.1;
    z-index: 0;
  }

  .container-fluid {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
  }

  .popup-mahila {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    padding: 40px;
    border-radius: var(--border-radius);
    box-shadow: var(--shadow-medium);
    border: 1px solid rgba(255, 255, 255, 0.2);
    position: relative;
    overflow: hidden;
    animation: slideUp 0.6s ease-out;
  }

  .popup-mahila::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: var(--primary-gradient);
  }

  /* Header da página */
  .page-header {
    text-align: center;
    margin-bottom: 30px;
  }

  .page-icon {
    font-size: 3rem;
    margin-bottom: 15px;
    display: inline-block;
    animation: float 3s ease-in-out infinite;
  }

  .page-title {
    font-size: 2rem;
    font-weight: 800;
    background: var(--primary-gradient);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 8px;
    line-height: 1.2;
  }

  .page-subtitle {
    font-size: 1rem;
    color: var(--text-secondary);
    font-weight: 500;
  }

  /* Formulários */
  .form-group {
    margin-bottom: 24px;
  }

  .form-label {
    display: block;
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 8px;
    font-size: 0.95rem;
  }

  .form-control {
    width: 100%;
    padding: 16px 20px;
    border: 2px solid #e5e7eb;
    border-radius: 12px;
    font-size: 1rem;
    font-family: inherit;
    background: var(--white);
    transition: var(--transition);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
  }

  .form-control:focus {
    outline: none;
    border-color: var(--accent-color);
    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
    transform: translateY(-1px);
  }

  .form-control:hover {
    border-color: #d1d5db;
  }

  .btn-enviar {
    width: 100%;
    padding: 16px 24px;
    background: var(--primary-gradient);
    color: var(--white);
    border: none;
    border-radius: 12px;
    font-size: 1rem;
    font-weight: 600;
    font-family: inherit;
    cursor: pointer;
    transition: var(--transition);
    box-shadow: var(--shadow-soft);
    position: relative;
    overflow: hidden;
  }

  .btn-enviar:hover {
    transform: translateY(-2px);
    box-shadow: var(--shadow-medium);
  }

  .btn-enviar:active {
    transform: translateY(0);
  }

  .btn-enviar::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
    transition: left 0.5s;
  }

  .btn-enviar:hover::before {
    left: 100%;
  }

  /* Seção de informações */
  .info-text {
    font-size: 1rem;
    color: var(--text-primary);
    line-height: 1.6;
    margin-bottom: 20px;
    text-align: center;
  }

  .divider {
    height: 1px;
    background: linear-gradient(to right, transparent, #e5e7eb, transparent);
    margin: 30px 0;
    border: none;
  }

  /* Seção de suporte */
  .support-section {
    background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
    padding: 24px;
    border-radius: 15px;
    border-left: 4px solid #ef4444;
    margin-top: 30px;
  }

  .support-title {
    text-align: center;
    color: white;
    font-weight: 700;
    font-size: 1.2rem;
    margin-bottom: 16px;
  }

  .support-text {
    color: white;
    line-height: 1.6;
    font-size: 0.95rem;
  }

  .support-email {
    color: #1d4ed8;
    text-decoration: underline;
    font-weight: 600;
    transition: var(--transition);
  }

  .support-email:hover {
    color: #1e40af;
  }

  /* Estados de erro */
  .error-message {
    background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
    color: #dc2626;
    padding: 16px 20px;
    border-radius: 10px;
    border-left: 4px solid #ef4444;
    margin-top: 20px;
    font-size: 0.95rem;
    font-weight: 500;
  }

  /* Animações */
  @keyframes slideUp {
    from {
      opacity: 0;
      transform: translateY(30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes float {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
  }

  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.7;
    }
  }

  /* Responsividade */
  @media (max-width: 768px) {
    .fundo-mahila {
      padding: 15px;
      align-items: flex-start;
      padding-top: 40px;
    }

    .popup-mahila {
      padding: 30px 25px;
      margin: 0;
    }

    .page-title {
      font-size: 1.6rem;
    }

    .page-icon {
      font-size: 2.5rem;
    }

    .form-control {
      padding: 14px 16px;
    }

    .btn-enviar {
      padding: 14px 20px;
    }

    .support-section {
      padding: 20px;
    }
  }

  @media (max-width: 480px) {
    .fundo-mahila {
      padding: 10px;
      padding-top: 30px;
    }

    .popup-mahila {
      padding: 25px 20px;
      border-radius: 15px;
    }

    .page-title {
      font-size: 1.4rem;
    }

    .page-icon {
      font-size: 2rem;
    }

    .form-control {
      padding: 12px 14px;
      font-size: 16px; /* Previne zoom no iOS */
    }

    .btn-enviar {
      padding: 14px 18px;
      font-size: 16px; /* Previne zoom no iOS */
    }

    .info-text {
      font-size: 0.95rem;
    }

    .support-section {
      padding: 18px;
    }
  }

  /* Orientação paisagem para mobile */
  @media screen and (max-height: 500px) and (orientation: landscape) {
    .fundo-mahila {
      align-items: flex-start;
      padding-top: 20px;
    }

    .popup-mahila {
      padding: 20px;
    }

    .page-header {
      margin-bottom: 20px;
    }

    .form-group {
      margin-bottom: 16px;
    }

    .support-section {
      margin-top: 20px;
    }
  }

  /* Dark mode support */
  @media (prefers-color-scheme: dark) {
    :root {
      --text-primary: #f9fafb;
      --text-secondary: #d1d5db;
      --white: white;
    }

    .popup-mahila {
      background: rgba(31, 41, 55, 0.95);
      border-color: rgba(75, 85, 99, 0.3);
    }

    .form-control {
      background: #374151;
      border-color: #4b5563;
      color: #f9fafb;
    }

    .form-control:focus {
      border-color: #8b5cf6;
    }

    .support-section {
      background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
    }

    .error-message {
      background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
    }
  }

  /* Acessibilidade */
  .form-control:focus,
  .btn-enviar:focus {
    outline: 2px solid var(--accent-color);
    outline-offset: 2px;
  }

  /* Otimizações para touch devices */
  .btn-enviar,
  .form-control {
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
  }

  /* Performance optimizations */
  .popup-mahila,
  .btn-enviar {
    will-change: transform;
  }
</style>

<template>
  <div class="fundo-mahila">
    <div class="container-fluid">
      <!-- Primeira parte: Verificação de email -->
      <div v-if="parte1 && !parte2" class="popup-mahila">
        <!-- Header da página -->
        <div class="page-header">
          <div class="page-icon">📧</div>
          <h1 class="page-title">Acesso ao Mapa Numerológico</h1>
          <p class="page-subtitle">Verificação de acesso necessária</p>
        </div>

        <!-- Informações -->
        <p class="info-text">
          Por favor, digite abaixo o e-mail <strong>EXATAMENTE</strong> igual ao e-mail que utilizou no momento da sua compra.
        </p>

        <hr class="divider">

        <!-- Formulário de email -->
        <form @submit.prevent="checkIfUserInList">
          <div class="form-group">
            <label for="email" class="form-label">
              <span>✉️</span> E-mail de Compra:
            </label>
            <input 
              v-model="email" 
              type="email"
              id="email"
              class="form-control"
              placeholder="Digite seu e-mail aqui..."
              required
              autocomplete="email"
            />
          </div>

          <button type="submit" class="btn-enviar">
            <span>🔍</span> Verificar Acesso
          </button>
        </form>

        <!-- Seção de suporte -->
        <div class="support-section">
          <h3 class="support-title">Precisa de suporte?</h3>
          <p class="support-text">
            Não se preocupe, envie um e-mail com o seu <strong>Nome Completo</strong>, <strong>CPF</strong> e conte o que está acontecendo para podermos ajudar.
            <br><br>
            📬 Suporte: <a href="mailto:contato@mahilaluz.com" class="support-email">contato@mahilaluz.com</a>
            <br>
            <small>(note que o nosso e-mail não tem o ".br" no final)</small>
          </p>
        </div>
      </div>

      <!-- Segunda parte: Formulário de dados -->
      <div v-if="parte2" class="popup-mahila">
        <!-- Header da página -->
        <div class="page-header">
          <div class="page-icon">✨</div>
          <h1 class="page-title">Seu Mapa Numerológico</h1>
          <p class="page-subtitle">Preencha seus dados para gerar sua análise personalizada</p>
        </div>

        <!-- Informações -->
        <p class="info-text">
          Preencha o formulário abaixo e toque em <strong>Enviar</strong> para receber o seu Mapa Numerológico personalizado.
        </p>

        <hr class="divider">

        <!-- Formulário de dados -->
        <form @submit.prevent="handleSubmit">
          <div class="form-group">
            <label for="name" class="form-label">
              <span>👤</span> Nome Completo:
            </label>
            <input 
              v-model="name" 
              type="text" 
              id="name" 
              class="form-control"
              placeholder="Digite seu nome completo..."
              required
              autocomplete="name"
            >
          </div>

          <div class="form-group">
            <label for="birthdate" class="form-label">
              <span>🎂</span> Data de Nascimento:
            </label>
            <input 
              v-model="birthdate" 
              type="date" 
              id="birthdate" 
              class="form-control"
              required
              autocomplete="bday"
            >
          </div>

          <button type="submit" class="btn-enviar">
            <span>🚀</span> Gerar Meu Mapa Numerológico
          </button>
        </form>

        <!-- Mensagem de erro -->
        <div v-if="error" class="error-message">
          <strong>⚠️ Erro:</strong> {{ error }}
        </div>

        <!-- Seção de suporte -->
        <div class="support-section">
          <h3 class="support-title">Precisa de suporte?</h3>
          <p class="support-text">
            Não se preocupe, envie um e-mail com o seu <strong>Nome Completo</strong>, <strong>CPF</strong> e conte o que está acontecendo para podermos ajudar.
            <br><br>
            📬 Suporte: <a href="mailto:contato@mahilaluz.com" class="support-email">contato@mahilaluz.com</a>
            <br>
            <small>(note que o nosso e-mail não tem o ".br" no final)</small>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import apiService from '../services/apiService.js';
import { parseISO, getDate, getMonth, getYear } from 'date-fns';
import { Loader } from '@googlemaps/js-api-loader';
//import axios from 'axios';

export default {
  name: "PaginaPrincipal",
  components: {

  },
  data() {
    return {
      name: '',
      gender: '',
      birthdate: '',
      birthtime: '',
      unknownTime: false,
      autocomplete: null,
      lat: null,
      lng: null,
      timezone: null,
      place: '',
      showSigno: false,
      error: null,
      google: null,
      email: '',
      isInList: null,
      parte1: true,
      parte2: false
    };
  },
  mounted() {
    const loader = new Loader({
      apiKey: 'AIzaSyCbJ2m7_M9GBR1f3c-0EbvMjUDt5wc6IVY',
      libraries: ['places'],
    });

    this.google = loader.load();

    this.google = window.google;
    this.initAutocomplete();
  },
  methods: {
    async initAutocomplete() {

      const input = this.$refs.addressInput;
      this.autocomplete = new this.google.maps.places.Autocomplete(input, {
        types: ['geocode'],
      });

      this.autocomplete.addListener('place_changed', this.onPlaceChanged);
    },
    onPlaceChanged() {
      const place = this.autocomplete.getPlace();

      if (!place.geometry) {
        document.getElementById('output').innerText = 'Por favor, selecione um endereço válido.';
        return;
      }

      // Atualizar o valor do campo de entrada com o endereço completo
      this.$refs.addressInput.value = place.formatted_address;
      this.place = place.formatted_address;

      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();

      this.lat = lat;
      this.lng = lng;

      this.getTimeZone(lat, lng);

      
    },
    getTimeZone(lat, lng) {
      const timestamp = Math.floor(Date.now() / 1000);
      const timezoneAPI = `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${timestamp}&key=AIzaSyCbJ2m7_M9GBR1f3c-0EbvMjUDt5wc6IVY`;

      fetch(timezoneAPI)
        .then(response => response.json())
        .then(data => {
          if (data.status === 'OK') {
            const rawOffset = data.rawOffset; // Deslocamento UTC bruto em segundos
            const dstOffset = data.dstOffset; // Deslocamento devido ao horário de verão em segundos
            const totalOffset = (rawOffset + dstOffset) / 3600; // Converter de segundos para horas
            this.timezone = totalOffset;
          }
        })
        .catch(error => {
          console.error('Error fetching timezone:', error);
        });
    },
    async checkIfUserInList() {
      this.parte2 = true;
      this.parte1 = false;
      /*const brevoApiKey = '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';
      const listId = '5';  // Substitua pelo ID da sua lista na Brevo
      const emailToCheck = this.email;
      
      try {
        // Pesquisar o contato pelo email
        let contactResponse = await axios.get(`https://api.brevo.com/v3/contacts/${encodeURIComponent(emailToCheck)}`, {
          headers: {
            'api-key': brevoApiKey
          }
        });

        //const contactId = contactResponse.data.id;
        const contactLists = contactResponse.data.listIds;
        console.log(contactResponse);
        if(contactLists[0] == listId || contactLists[1] == listId) {
          this.isInList = true;
          this.parte2 = true;
          this.parte1 = false;
        }else{
          this.isInList = false;
          alert('Seu e-mail não foi encontrado. Contate o suporte.');
        }
      } catch (error) {
        if (this.isInList == null) {
          // Contato não encontrado
          this.isInList = false;
          alert('Seu e-mail não foi encontrado. Contate o suporte.');
        } else {
          console.error('Error checking contact list:', error);
        }
      }*/
    },
    handleSubmit() {
      this.error = null;
      if (!this.birthdate || !this.name ) {
        this.error = "Por favor, preencha todos os campos obrigatórios!";
        return;
      }


      const birthdate = parseISO(this.birthdate);

      const userData = {
        full_name: this.name,
        day: getDate(birthdate),
        month: getMonth(birthdate) + 1,
        year: getYear(birthdate),
        email: this.email
      };

      this.$router.push({
        name: 'HelloWorld',
        params: {
          full_name: this.name,
          day: userData.day,
          month: userData.month,
          year: userData.year,
          email: this.email
        }
      });

    }
  }
};
</script>